<script setup lang="ts">
import type { VideoRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ video: VideoRecord }>();
</script>

<template>
  <div>
    <VideoYouTube v-if="video.source.provider === 'youtube'" :video-id="video.source.providerUid" />
    <VideoVimeo v-if="video.source.provider === 'vimeo'" :video-id="video.source.providerUid" />
  </div>
</template>

<style scoped>

</style>
